export enum questionnaireActionTypes {
  CURRENT_QUESTIONNAIRE_LOADING = 'CURRENT_QUESTIONNAIRE_LOADING',
  SET_CURRENT_QUESTIONNAIRE = 'SET_CURRENT_QUESTIONNAIRE',
  SET_CURRENT_QUESTIONNAIRE_DATA = 'SET_CURRENT_QUESTIONNAIRE_DATA',
  SET_CURRENT_HEADER_LABELS = 'SET_CURRENT_HEADER_LABELS',
  SET_CURRENT_QUESTIONNAIRE_RENDERER = 'SET_CURRENT_QUESTIONNAIRE_RENDERER',
  CURRENT_QUESTIONNAIRE_FAILURE = 'CURRENT_QUESTIONNAIRE_FAILURE',
  QUESTIONNAIRES_LOADING = 'QUESTIONNAIRES_LOADING',
  SET_QUESTIONNAIRES = 'SET_QUESTIONNAIRES',
  QUESTIONNAIRES_FAILURE = 'QUESTIONNAIRES_FAILURE',
  SET_QUESTIONNAIRES_TOTAL = 'SET_QUESTIONNAIRES_TOTAL',
  SET_QUESTIONNAIRES_LIMIT = 'SET_QUESTIONNAIRES_LIMIT',
  SET_QUESTIONNAIRES_OFFSET = 'SET_QUESTIONNAIRES_OFFSET',
  //// POST/PUT/DELETE
  EDITING_QUESTIONNAIRE_LOADING = 'EDITING_QUESTIONNAIRE_LOADING',
  SET_EDITING_QUESTIONNAIRE = 'SET_EDITING_QUESTIONNAIRE',
  EDITING_QUESTIONNAIRE_FAILURE = 'EDITING_QUESTIONNAIRE_FAILURE',
  DELETING_QUESTIONNAIRE_LOADING = 'DELETING_QUESTIONNAIRE_LOADING',
  DELETING_QUESTIONNAIRE_FAILURE = 'DELETING_QUESTIONNAIRE_FAILURE',
}
